import {
  CaretRightOutlined,
  Loading3QuartersOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  GetProp,
  Image,
  Row,
  Spin,
  Tag,
} from "antd";
import {
  AngleRight,
  ConstructionIcon,
  CrossIcon,
  EnhancementsIcon,
  HolidayLightingIcon,
  IrrigationIcon,
  LandscapeIcon,
  LawnCareIcon,
  SnowServiceIcon,
  TreeServiceIcon,
} from "../../../../../../../atoms/CustomIcons";
import EmptyCard from "../../../../../../../atoms/EmptyCard";
import Meta from "antd/es/card/Meta";
import { Fragment, useState } from "react";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
}

const CatalogueModal = (props: PropsType) => {
  const { onClose } = props;
  const [servicesList, showServicesList] = useState(false);

  const onChange: GetProp<typeof Checkbox.Group, "onChange"> = (
    checkedValues
  ) => {
    console.log("checked = ", checkedValues);
  };

  const serviceCategoryList = [
    {
      title: "Site preparation",
      services: [
        "Excavation",
        "Grading",
        "Trenching",
        "Silt fence installation",
        "Erosion control blanket installation",
        "Soil amendment application",
        "Soil compaction",
        "Soil testing",
      ],
    },
    {
      title: "Sod installation",
      services: [
        "Sod installation",
        "Sod removal",
        "Sod preparation",
        "Sod delivery",
      ],
    },
    {
      title: "Seeding",
      services: [
        "Seeding (lawn)",
        "Seeding (wildflower)",
        "Seeding (native plants)",
      ],
    },
    {
      title: "Planting",
      services: [
        "Tree planting",
        "Shrub planting",
        "Perennial planting",
        "Annual planting",
      ],
    },
    {
      title: "Mulching",
      services: ["Mulch installation", "Mulch delivery", "Mulch removal"],
    },
    {
      title: "Annual flowers installation",
      services: ["Annual flowers installation", "Annual flowers removal"],
    },
  ];

  return (
    <Spin indicator={antIcon} size="large" spinning={false}>
      <div className="services_estimate_selection">
        <div className="modal_header">
          <h2> Select services </h2>
          <Button onClick={() => onClose()} icon={<CrossIcon />} />
        </div>
        <div className="modal_body">
          <div className="current_selection">
            <div className="select_service_icon">
              <ul>
                <li>
                  <Button type="text">
                    <LandscapeIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <EnhancementsIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <LawnCareIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <IrrigationIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <TreeServiceIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <ConstructionIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <HolidayLightingIcon className="defaultColor" />
                  </Button>
                </li>
                <li>
                  <Button type="text">
                    <SnowServiceIcon className="defaultColor" />
                  </Button>
                </li>
              </ul>
            </div>
            <div className="select_service_card">
              {servicesList ? (
                <div className="serviceListWrapper">
                  <div className="listHeader">
                    <Button
                      icon={<AngleRight />}
                      onClick={() => showServicesList(false)}
                      style={{ transform: "rotate(180deg)" }}
                    />
                    <div className="listBreadCrumb">
                      Construction &nbsp; / &nbsp;
                      <span>Soft scape and site preparation</span>
                    </div>
                  </div>

                  <div className="serviceCategoryHeadings">
                    {serviceCategoryList.map((category, index) => (
                      <Fragment key={index}>
                        <Button className="outlined-btn">
                          {category.title}
                        </Button>
                      </Fragment>
                    ))}
                  </div>

                  <div className="serviceCategoryList">
                    <Checkbox.Group
                      style={{ width: "100%" }}
                      onChange={onChange}
                    >
                      <Row gutter={8}>
                        {serviceCategoryList.map((category, index) => (
                          <Fragment key={index}>
                            {category.services.map((service, index) => (
                              <Col key={index} span={8}>
                                <Checkbox value={service}>{service}</Checkbox>
                              </Col>
                            ))}
                          </Fragment>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </div>
                </div>
              ) : (
                <>
                  <h3 style={{ marginBottom: "17px" }}> Construction: </h3>
                  <Row gutter={12} style={{ flex: "1" }}>
                    <Col span={8} style={{ display: "flex" }}>
                      <Card
                        className="inner_cards"
                        onClick={() => showServicesList(true)}
                      >
                        <Meta
                          avatar={
                            <Avatar
                              size={36}
                              style={{ flex: "none" }}
                              shape="square"
                            />
                          }
                          title={
                            <>
                              Soft scape and site <br /> preparation
                              <Tag className="defaultTag light_purple_tag">
                                In-house
                              </Tag>
                            </>
                          }
                          description="Preparing the landscape for planting, including soil grading, mulching, and sod installation."
                        />
                        <div className="checkboxIcon">
                          <Image
                            src="/images/services/checkbox-unfilled.svg"
                            preview={false}
                          />
                          <Image
                            src="/images/services/checkbox-filled.svg"
                            preview={false}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col span={8} style={{ display: "flex" }}>
                      <Card className="inner_cards">
                        <Meta
                          avatar={
                            <Avatar
                              size={36}
                              style={{ flex: "none" }}
                              shape="square"
                            />
                          }
                          title={
                            <>
                              Hardscape
                              <Tag className="defaultTag light_purple_tag">
                                In-house
                              </Tag>
                            </>
                          }
                          description="Installation of non-living elements such as walkways, patios, retaining walls, and driveways."
                        />
                        <div className="checkboxIcon">
                          <Image
                            src="/images/services/checkbox-unfilled.svg"
                            preview={false}
                          />
                          <Image
                            src="/images/services/checkbox-filled.svg"
                            preview={false}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col span={8} style={{ display: "flex" }}>
                      <Card className="inner_cards">
                        <Meta
                          avatar={
                            <Avatar
                              size={36}
                              style={{ flex: "none" }}
                              shape="square"
                            />
                          }
                          title={
                            <>
                              Drainage
                              <Tag className="defaultTag light_purple_tag">
                                In-house
                              </Tag>
                            </>
                          }
                          description="Design and implementation of water management systems, including trenching, grading."
                        />
                        <div className="checkboxIcon">
                          <Image
                            src="/images/services/checkbox-unfilled.svg"
                            preview={false}
                          />
                          <Image
                            src="/images/services/checkbox-filled.svg"
                            preview={false}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </div>
          <div className="current_selection_empty">
            <div className="empty_card">
              <EmptyCard
                title="No services selected yet"
                description={
                  <>
                    Select services from the list on the left <br /> to add them
                    to your estimate.
                  </>
                }
                image="/images/empty-icons/no-archived.svg"
              />
            </div>

            <div className="cardCollapse">
              <h5> Selected services </h5>
              <Collapse
                items={[
                  {
                    key: "1",
                    label: "Soft scape and site preparation",
                    children: (
                      <ul>
                        <li> Transplanting </li>
                        <li> Dumpster / Roll off (20 cy) </li>
                        <li> Dumpster / Roll off (30 cy) </li>
                        <li> Sod removal </li>
                      </ul>
                    ),
                  },
                ]}
                defaultActiveKey={["1"]}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    rotate={isActive ? 265 : 90}
                    style={{ marginRight: "5px" }}
                  />
                )}
              />
            </div>

            <Button
              className="mint-btn"
              disabled
              style={{ marginLeft: "auto" }}
            >
              Add to the estimate
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default CatalogueModal;
